<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form"  :rules="rules">
      <a-form-model-item prop="shopId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品库存后台审核变动记录. 店铺id')}}<template slot="title">{{$t('商品库存后台审核变动记录. 店铺id')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.shopId"  :placeholder="$t('通用.输入.请输入')+$t('商品库存后台审核变动记录. 店铺id')" />
      </a-form-model-item>
      <a-form-model-item prop="goodsId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品库存后台审核变动记录.商品编号')}}<template slot="title">{{$t('商品库存后台审核变动记录.商品编号')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.goodsId"  :placeholder="$t('通用.输入.请输入')+$t('商品库存后台审核变动记录.商品编号')" />
      </a-form-model-item>
      <a-form-model-item prop="skuId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品库存后台审核变动记录.skuid')}}<template slot="title">{{$t('商品库存后台审核变动记录.skuid')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.skuId"  :placeholder="$t('通用.输入.请输入')+$t('商品库存后台审核变动记录.skuid')" />
      </a-form-model-item>
      <a-form-model-item prop="orderId" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品库存后台审核变动记录.订单id')}}<template slot="title">{{$t('商品库存后台审核变动记录.订单id')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.orderId"  :placeholder="$t('通用.输入.请输入')+$t('商品库存后台审核变动记录.订单id')" />
      </a-form-model-item>
      <a-form-model-item prop="isLock" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品库存后台审核变动记录.是否锁定 1:锁定,0:未锁定')}}<template slot="title">{{$t('商品库存后台审核变动记录.是否锁定 1:锁定,0:未锁定')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.isLock"  :placeholder="$t('通用.输入.请输入')+$t('商品库存后台审核变动记录.是否锁定 1:锁定,0:未锁定')" />
      </a-form-model-item>
      <a-form-model-item prop="stockBefore" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品库存后台审核变动记录.库存变动前')}}<template slot="title">{{$t('商品库存后台审核变动记录.库存变动前')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.stockBefore"  :placeholder="$t('通用.输入.请输入')+$t('商品库存后台审核变动记录.库存变动前')" />
      </a-form-model-item>
      <a-form-model-item prop="stockAfter" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品库存后台审核变动记录.库存变动后')}}<template slot="title">{{$t('商品库存后台审核变动记录.库存变动后')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.stockAfter"  :placeholder="$t('通用.输入.请输入')+$t('商品库存后台审核变动记录.库存变动后')" />
      </a-form-model-item>
      <a-form-model-item prop="stock" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品库存后台审核变动记录.库存变动量')}}<template slot="title">{{$t('商品库存后台审核变动记录.库存变动量')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.stock"  :placeholder="$t('通用.输入.请输入')+$t('商品库存后台审核变动记录.库存变动量')" />
      </a-form-model-item>
      <a-form-model-item prop="remark" >
        <span slot="label" >
          <a-tooltip>
            {{$t('商品库存后台审核变动记录.备注')}}<template slot="title">{{$t('商品库存后台审核变动记录.备注')}}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.remark" :placeholder="$t('通用.输入.请输入')" type="textarea" allow-clear />
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video style="width: 100%" :src="previewUrl" ref="myVideo"
               :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'" :controls="true"></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{$t('通用.按钮.保存')}}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{$t('通用.按钮.取消')}}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getSkuAdmStockLog, addSkuAdmStockLog, updateSkuAdmStockLog } from '@/api/goods/skuAdmStockLog'
import {mapGetters} from 'vuex'
import CustomDictTag from "@/components/DictCustomTag";
import {generateFilePath, uploadObject} from "@/api/tool/oss";


export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    CustomDictTag,
  },
  data () {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        shopId: null,

        goodsId: null,

        skuId: null,

        orderId: null,

        isLock: null,

        stockBefore: null,

        stockAfter: null,

        stock: null,

        createTime: null,

        remark: null

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        goodsId: [
          { required: true, message: this.$t('商品库存后台审核变动记录.商品编号')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        orderId: [
          { required: true, message: this.$t('商品库存后台审核变动记录.订单id')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        stockBefore: [
          { required: true, message: this.$t('商品库存后台审核变动记录.库存变动前')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        stockAfter: [
          { required: true, message: this.$t('商品库存后台审核变动记录.库存变动后')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ],
        stock: [
          { required: true, message: this.$t('商品库存后台审核变动记录.库存变动量')+this.$t('通用.文本.不能为空'), trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    ...mapGetters(['customDict'])
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel () {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false;
    },
    previewVideoCancel() {
      this.previewVideoVisible = false;
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        shopId: null,
        goodsId: null,
        skuId: null,
        orderId: null,
        isLock: null,
        stockBefore: null,
        stockAfter: null,
        stock: null,
        createTime: null,
        remark: null
      }

    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getSkuAdmStockLog({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          let message = '';
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateSkuAdmStockLog(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            message = this.$t('通用.文本.修改成功')
            addSkuAdmStockLog(this.form).then(response => {
              this.$message.success(
                message,
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
